import React, { Component } from 'react'
import axios from 'axios'
import { sn_url } from './../../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'

export default function zonePosts(slug, id, limit = 5) {
    return function wrapWithZonePosts(WrappedComponent) {
        class ZonePosts extends Component {
            constructor() {
                super()
                this.source = null
                this.mounted = false
                this.renderedElement = ''
                this.cacheLength = 60 //seconds

                this.state = {
                    isFetching: true,
                    zonePosts: {},
                }
            }

            componentDidMount() {
                this.mounted = true
                this.source = axios.CancelToken.source()

                if (typeof localStorage === 'object') {
                    const zonePosts_storage = localStorage.getItem(`${slug}_${id}_zonePosts`)
                    const zonePosts_timestamp_storage = localStorage.getItem(
                        `${slug}_${id}_zonePosts_timestamp`
                    )

                    if (
                        Math.round(+new Date() / 1000) - zonePosts_timestamp_storage <
                        this.cacheLength
                    ) {
                        this.setState({
                            zonePosts: JSON.parse(zonePosts_storage),
                            isFetching: false,
                        })
                    } else {
                        this.getZonePosts()
                    }
                } else {
                    this.getZonePosts()
                }
            }

            componentWillUnmount() {
                this.mounted = false
                if (this.source) this.source.cancel()
            }

            getZonePosts() {
                axios
                    .get(`${sn_url}/wp-json/sportsnet/v1/zones/${slug}?limit=${limit}`, {
                        cancelToken: this.source.token,
                        headers: { 'Content-Type': 'application/json' },
                    })
                    .then(response => {
                        if (this.mounted) {
                            this.setState(
                                {
                                    zonePosts: response.data,
                                    isFetching: false,
                                },
                                () => {
                                    if (typeof localStorage === 'object') {
                                        localStorage.setItem(
                                            `${slug}_${id}_zonePosts`,
                                            JSON.stringify(response.data)
                                        )
                                        localStorage.setItem(
                                            `${slug}_${id}_zonePosts_timestamp`,
                                            Math.round(+new Date() / 1000)
                                        )
                                    }
                                }
                            )
                        }
                    })
                    .catch(error => {
                        if (!axios.isCancel(error) && this.mounted) {
                            this.setState({
                                isFetching: false,
                            })
                        }
                        handleError(error)
                    })
            }

            render() {
                if (!this.state.isFetching) {
                    this.renderedElement = React.createElement(WrappedComponent, {
                        zone_posts: this.state.zonePosts,
                        ...this.props,
                    })
                }

                return this.renderedElement
            }
        }

        return ZonePosts
    }
}
